// Version : 0.0.2
// Author : Nandhakumar
// Last Add : 'Converted Existed Values for the Keys from Upper Case to Smaller Case'
// Modified Date : 4-12-2025

/* eslint-disable import/no-anonymous-default-export */
import GoldLoanActionTypes from './gold-loan-collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Gold Loan Index Details Response
	getGoldLoanIndexDetailsResponse: null,
	getGoldLoanIndexDetailsArr: [],
	// Gold Loan Index Info Response
	getGoldLoanIndexInfoResponse: null,
	getGoldLoanIndexInfoArr: [],
	// Delete Gold Loan Index Response
	deleteGoldLoanIndexResponse: null,
	// Get Particular Gold Loan Index Info Response
	getParticularGoldLoanIndexInfoResponse: null,
	getParticularGoldLoanIndexInfoArr: [],
	// Update Gold Loan Index Collection Response
	updateGoldLoanIndexCollectionResponse: null,
	// Member Gold Collection Details Response
	getMemberGoldCollectionDetailsResponse: null,
	getMemberGoldCollectionDetailsArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET GOLD LOAN INDEX DETAILS START *********************** */
		case GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				getGoldLoanIndexDetailsResponse: action.payload,
				getGoldLoanIndexDetailsArr: docodeHexResponse(
					action.payload,
					'GetGoldLoanIndexDetailsKey',
				),
			};

		case GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_FAILURE:
			return { ...state, getGoldLoanIndexDetailsResponse: action.payload };

		case GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, getGoldLoanIndexDetailsResponse: null };
		/** ***************** GET GOLD LOAN INDEX DETAILS END *********************** */

		/** ***************** GET GOLD LOAN INDEX INFO START *********************** */
		case GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_SUCCESS:
			return {
				...state,
				getGoldLoanIndexInfoResponse: action.payload,
				getGoldLoanIndexInfoArr: docodeHexResponse(
					action.payload,
					'GetLoanInfoBasedOnGoldLoanIndexDataKey',
				),
			};

		case GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_FAILURE:
			return { ...state, getGoldLoanIndexInfoResponse: action.payload };

		case GoldLoanActionTypes.GET_GOLD_LOAN_INDEX_INFO_RESPONSE_CHANGED:
			return { ...state, getGoldLoanIndexInfoResponse: null };
		/** ***************** GET GOLD LOAN INDEX INFO END *********************** */

		/** ***************** DELETE GOLD LOAN INDEX START *********************** */
		case GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_SUCCESS:
			// Storing Response in state
			return {
				...state,
				deleteGoldLoanIndexResponse: action.payload,
			};

		case GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_FAILURE:
			return { ...state, deleteGoldLoanIndexResponse: action.payload };

		case GoldLoanActionTypes.DELETE_GOLD_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, deleteGoldLoanIndexResponse: null };
		/** ***************** DELETE GOLD LOAN INDEX END *********************** */
		/** ***************** GET PARTICULAR GOLD LOAN INDEX INFO START *********************** */
		case GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_SUCCESS:
			// Storing Response and List in state
			return {
				...state,
				getParticularGoldLoanIndexInfoResponse: action.payload,
				getParticularGoldLoanIndexInfoArr: docodeHexResponse(
					action.payload,
					'GetParticularGoldLoanIndexKey',
				),
			};

		case GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_FAILURE:
			return { ...state, getParticularGoldLoanIndexInfoResponse: action.payload };

		case GoldLoanActionTypes.GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_RESPONSE_CHANGED:
			return { ...state, getParticularGoldLoanIndexInfoResponse: null };
		/** ***************** GET PARTICULAR GOLD LOAN INDEX INFO END *********************** */
		/** ***************** UPDATE GOLD LOAN INDEX COLLECTION START *********************** */
		case GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_SUCCESS:
			// Storing Response in state
			return {
				...state,
				updateGoldLoanIndexCollectionResponse: action.payload,
			};

		case GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_FAILURE:
			return { ...state, updateGoldLoanIndexCollectionResponse: action.payload };

		case GoldLoanActionTypes.UPDATE_GOLD_LOAN_INDEX_COLLECTION_RESPONSE_CHANGED:
			return { ...state, updateGoldLoanIndexCollectionResponse: null };
		/** ***************** UPDATE GOLD LOAN INDEX COLLECTION END *********************** */
		/** ***************** GET MEMBER GOLD COLLECTION DETAILS START *********************** */
		case GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_SUCCESS:
			// Storing Response and List in state
			return {
				...state,
				getMemberGoldCollectionDetailsResponse: action.payload,
				getMemberGoldCollectionDetailsArr: docodeHexResponse(
					action.payload,
					'GetMemberGoldCollectionDetailsKey',
				),
			};

		case GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_FAILURE:
			return { ...state, getMemberGoldCollectionDetailsResponse: action.payload };

		case GoldLoanActionTypes.GET_MEMBER_GOLD_COLLECTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, getMemberGoldCollectionDetailsResponse: null };
		/** ***************** GET MEMBER GOLD COLLECTION DETAILS END *********************** */
		default:
			return state;
	}
};
